import React, { useState } from 'react'
import PropTypes from 'prop-types'
import { CircularProgress, Grid, Typography, useTheme, useMediaQuery, Box, Paper, IconButton, Collapse } from '@material-ui/core'
import ExpandMoreIcon from '@material-ui/icons/ExpandMore'
import ExpandLessIcon from '@material-ui/icons/ExpandLess'
import { getLabelEndereco } from 'helpers/labels'
import { CustomTable } from 'components'
import { useStyles } from './ListaLocais.styles'
import { useListaLocais } from './hooks/useListaLocais'
import { FormLocal } from '../FormLocal'

export const ListaLocais = ({ idExameSolicitado, idExameRealizado, setFormLocaisErro }) => {
  const classes = useStyles()
  const theme = useTheme()
  const isMobile = useMediaQuery(theme.breakpoints.down('xs'))
  const { carregando, locais, fetchLocais, getAnaliseLocalDeExame } = useListaLocais({
    idExameSolicitado,
    idExameRealizado,
    setFormLocaisErro,
  })

  const [localExpandidoId, setLocalExpandidoId] = useState(null)

  const handleToggleExpandir = (id) => {
    setLocalExpandidoId((prev) => (prev === id ? null : id))
  }

  const columns = [
    {
      title: 'Endereço',
      render: (rowData) => getLabelEndereco(rowData),
    },
    {
      title: 'Análise do local',
      render: (rowData) =>
        getAnaliseLocalDeExame(rowData) ? (
          <Typography className={classes.positive} style={{ fontSize: '12px' }}>
            Local analisado
          </Typography>
        ) : (
          <Typography className={classes.negative} style={{ fontSize: '12px' }}>
            Local não analisado
          </Typography>
        ),
      width: '30%',
    },
  ]

  return (
    <div>
      {carregando ? (
        <div className={classes.carregando}>
          <CircularProgress disableShrink />
        </div>
      ) : (
        <div>
          <Grid item md={12} sm={12} xs={12} className={classes.tableContainer}>
            {isMobile ? (
              locais && locais.length > 0 ? (
                <Grid container spacing={2}>
                  {locais.map((item) => {
                    const isExpanded = localExpandidoId === item.id
                    const analisado = getAnaliseLocalDeExame(item)
                    return (
                      <Grid item xs={12} key={item.id}>
                        <Paper className={classes.localCard}>
                          <Box
                            display="flex"
                            justifyContent="space-between"
                            alignItems="center"
                            onClick={() => handleToggleExpandir(item.id)}
                            style={{ cursor: 'pointer' }}
                          >
                            <Box pr={1}>
                              <Typography
                                variant="subtitle2"
                                style={{ fontWeight: 'bold', fontSize: '13px' }}
                              >
                                {getLabelEndereco(item)}
                              </Typography>
                            </Box>
                            <Box display="flex" alignItems="center">
                              {analisado ? (
                                <span className={classes.chipStatusSuccess}>Analisado</span>
                              ) : (
                                <span className={classes.chipStatusWarning}>Pendente</span>
                              )}
                              <IconButton size="small" style={{ marginLeft: '8px' }}>
                                {isExpanded ? <ExpandLessIcon /> : <ExpandMoreIcon />}
                              </IconButton>
                            </Box>
                          </Box>
                          <Collapse in={isExpanded} timeout="auto" unmountOnExit>
                            <Box className={classes.expandedFormContainer}>
                              <FormLocal
                                idLocal={item.id}
                                fetchLocais={fetchLocais}
                                idExameRealizado={idExameRealizado}
                                onConfirmSuccess={() => setLocalExpandidoId(null)}
                              />
                            </Box>
                          </Collapse>
                        </Paper>
                      </Grid>
                    )
                  })}
                </Grid>
              ) : (
                <Typography
                  style={{
                    fontSize: '12px',
                    padding: '24px',
                    textAlign: 'center',
                    color: '#999',
                    fontStyle: 'italic',
                  }}
                >
                  Nenhum local cadastrado neste exame
                </Typography>
              )
            ) : (
              <CustomTable
                title=""
                columns={columns}
                data={locais}
                onRowClick={(event, rowData, togglePanel) => togglePanel()}
                detailPanel={(rowData) => (
                  <FormLocal
                    idLocal={rowData.id}
                    fetchLocais={fetchLocais}
                    idExameRealizado={idExameRealizado}
                  />
                )}
                options={{
                  search: false,
                  pageSize: 5,
                  paging: false,
                  headerStyle: {
                    backgroundColor: '#f4f6f8',
                    fontSize: '12px',
                  },
                  toolbar: false,
                }}
              />
            )}
          </Grid>
        </div>
      )}
    </div>
  )
}

ListaLocais.propTypes = {
  idExameSolicitado: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
  idExameRealizado: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
  setFormLocaisErro: PropTypes.func.isRequired,
}
